import { Hanko, register } from "@teamhanko/hanko-elements"
import { useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Link } from "@mui/material";
import logo from '../assets/hanko-logo.svg'
import { Footer } from "../components/Footer";
import { ElementsBackground } from "../components/Background";

export const Login = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const hanko = useMemo(() => new Hanko(window.REACT_APP_LOGIN_PROVIDER_URL), [])

  const redirectAfterLogin = useCallback(() => {
    if (state) {
      navigate((state as string), { replace: true })
    } else {
      navigate("/organizations/", { replace: true })
    }
  }, [navigate, state])

  useEffect(() => {
    hanko.validateSession().then((result) => {
      if (result.is_valid) {
        redirectAfterLogin()
      }
    })
  }, []);

  useEffect(() => {
    hanko.onSessionCreated(() => {
      redirectAfterLogin()
    })
  }, [hanko, redirectAfterLogin])

  return <Box sx={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignContent: 'space-between',
    gap: { xs: 3, md: 9 },
    background: 'radial-gradient(50% 50% at 50% 50%, #121526 0%, #121212 100%)',
    maxWidth: '420px',
    width: '100%',
    justifySelf: 'center',
    marginX: 'auto'
  }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6, mb: { xs: 3, md: 9 } }}>
      <img src={logo} alt="Hanko logo" style={{ width: '100%', maxWidth: '150px', height: '50px' }} />
    </Box>
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 5,
      margin: 1,
      alignContent: 'center',
      flexWrap: 'wrap',
      width: 'calc(100% - 16px)',
    }}>
      <ElementsBackground sx={{
        width: '100%',
        minHeight: '352px',
        alignContent: 'center',
      }}>
        <hanko-login lang="en" />
      </ElementsBackground>
      <ElementsBackground sx={{
        padding: '16px',
        textAlign: 'center',
      }}>
        Don't have an account? <Link sx={{ textDecoration: 'none' }} href="/signup">Sign up</Link>
      </ElementsBackground>
    </Box>
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      mt: { xs: 3, md: 9 },
      mb: 6,
      maxWidth: '500px',
      width: '100%',
      alignSelf: 'center',
    }}>
      <Footer />
    </Box>
  </Box>
}
